export interface DefaultIndicatorsDto {
    upperPressureMin?: number | '';
    upperPressureMax?: number | '';
    lowerPressureMin?: number | '';
    lowerPressureMax?: number | '';
    pulseMin?: number | '';
    pulseMax?: number | '';
    temperatureMax?: number | '';
}

export const emptyIndicators: DefaultIndicatorsDto = {};
